module.exports = __webpack_public_path__ + "img/custo-beneficio.ddcaa66b.png";